import { useOmniOfferShowQuery } from "@/services/backend/omni/offer/api/offer-api";
import { OfferPositionsPage } from "@/services/backend/wrh/offer/components/offer-positions-page";
import { CardSkeleton } from "@/shared/components/card-skeleton";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useParams } from "react-router";

export function OfferPositionsRoute() {
  const { offerId } = useParams();

  const { data, isLoading, error } = useOmniOfferShowQuery({
    id: offerId!,
  });

  return (
    <div>
      {error && <RTKQueryErrorAlert error={error} />}
      {isLoading && <CardSkeleton />}
      {data && <OfferPositionsPage offer={data} />}
    </div>
  );
}
